<template>
  <q-btn :icon="icon" :title="title" v-bind="$attrs" @click="openModal">
    <q-tooltip>
      {{ title }}
    </q-tooltip>
  </q-btn>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { PostGroup } from '@/type';
import openModal from '@/components/modal';
import { isPhotoAlbum } from '@/social/post/post';

export default defineComponent({
  props: {
    postGroup: {
      type: Object as () => PostGroup,
      required: true,
    },
  },
  computed: {
    icon(): string {
      if (isPhotoAlbum(this.postGroup.type)) {
        return 'fa fa-images';
      }
      return 'fa fa-clone';
    },
    title(): string {
      if (isPhotoAlbum(this.postGroup.type)) {
        return 'View Photo Album';
      }
      return 'View Entire Post';
    },
  },
  methods: {
    async openModal() {
      if (isPhotoAlbum(this.postGroup.type)) {
        const { default: PhotoAlbumModal } = await import('./PhotoAlbumModal.vue');
        openModal(PhotoAlbumModal, { album: this.postGroup });
        return;
      }

      const { default: PostGroupModal } = await import('./PostGroupModal.vue');
      openModal(PostGroupModal, { group: this.postGroup });
    },
  },
});
</script>
